import { observable, action, runInAction, toJS } from 'mobx'
import { message } from 'antd'
import $http from '@/utils/http'
import { PageSize } from '@/constants'
import { DictionaryType, DictionaryConfig } from './type'

export class EmpManageStore {
  @observable staffLists = []
  @observable loading = false
  @observable total = 0
  @observable pageNum = 1
  @observable searchEmpName = ''

  @observable idTypes: DictionaryConfig[] = []
  @observable departments: DictionaryConfig[] = []
  @observable positions: DictionaryConfig[] = []
  @observable inviteModal = false
  @observable stepOne = true

  @observable proofOfEmploymentViewStore: IFileUpload[] = []
  @observable proofOfEmployment = ''

  @observable initialFormValue = {
    code: '',
    name: '',
    idType: [],
    idNo: '',
    mobile: '',
    workEmail: '',
    dept: { extraDept: undefined, dept: undefined },
    position: { extraPosition: undefined, position: undefined },
    // positionCode: undefined,
    creditLimit: 0
  }

  //获取员工列表
  @action getStafflists = (employeeName = '') => {
    this.loading = true

    $http
      .post('/ent/employee/list', {
        employeeName,
        entId: 0,
        pageNum: this.pageNum,
        pageSize: PageSize,
        state: ''
      })
      .then(res => {
        runInAction(() => {
          this.staffLists = res.list
          this.total = res.total
        })
      })
      .catch(err => {
        message.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  //设置搜索的员工姓名
  @action setSearchEmpName = (searchEmpName: string) => {
    this.searchEmpName = searchEmpName
  }
  // 处理表格分页变化
  @action handlePagination = pagination => {
    this.pageNum = pagination.current
    this.getStafflists()
  }

  //邀请表单获取下拉列表数据
  @action getDictionary = (type: DictionaryType) => {
    return new Promise(resolve => {
      $http
        .get(`/dictionary/${type}`)
        .then(res => {
          runInAction(() => {
            resolve(JSON.stringify(res))
          })
        })
        .catch(err => {
          message.error(err)
        })
    })
  }

  @action setFormValue = (values: any) => {
    this.initialFormValue = values
  }
  @action changeInviteModal = async (inviteModal: boolean) => {
    this.inviteModal = inviteModal

    if (inviteModal) {
      const [idTypes, departments, positions] = await Promise.all([
        this.getDictionary('idType'),
        this.getDictionary('ent/department'),
        this.getDictionary('ent/position')
      ])
      this.idTypes = idTypes as DictionaryConfig[]
      this.departments = departments as DictionaryConfig[]
      this.positions = positions as DictionaryConfig[]
    }
  }
  @action changeStepOne = (stepOne: boolean) => {
    this.stepOne = stepOne
  }
  @action setProofOfEmploymentStore = (proofOfEmployment: IFileUpload[]) => {
    proofOfEmployment = toJS(proofOfEmployment)
    this.proofOfEmploymentViewStore = proofOfEmployment
    this.proofOfEmployment = proofOfEmployment[0] && proofOfEmployment[0].path
  }
  // 邀请员工
  @action reqInviteEmp = (staffInfo: any) => {
    $http
      .post('/ent/employee/invite', {
        ...staffInfo,
        proofOfEmployment: this.proofOfEmployment
      })
      .then(res => {
        message.success(res)
        this.setFormValue({
          code: '',
          name: '',
          idType: [],
          idNo: '',
          mobile: '',
          workEmail: '',
          dept: { extraDept: undefined, dept: undefined },
          positionCode: undefined,
          creditLimit: 0
        })
        this.changeInviteModal(false)
        this.setProofOfEmploymentStore([])
        this.getStafflists()
        setTimeout(() => {
          this.changeStepOne(true)
        }, 500)
      })
      .catch(err => {
        message.error(err)
      })
  }
}

export default new EmpManageStore()
